import { ReviewTemplatesModalContent } from 'components/ReviewTemplatesModal/ReviewTemplatesModal'
import { ReviewTemplate } from 'types'
import { EventId } from '../machineTypes'
import { useReviewsWizard } from '../ReviewsWizardProvider'

interface Props {
  workspaceId: number
}

export const AllTemplates = ({ workspaceId }: Props) => {
  const { service } = useReviewsWizard()
  const handleSelect = (template: ReviewTemplate) => {
    service.send([{ type: EventId.SELECT_REVIEW_TEMPLATE, reviewTemplate: template }])
  }
  const handleBack = () => {
    service.send({ type: EventId.BACK })
  }
  return <ReviewTemplatesModalContent workspaceId={workspaceId} onSelect={handleSelect} onBack={handleBack} />
}
